<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title mb-0"><i class="fas fa-cash-register me-2 text-primary"></i> Módulo Transbank Smart POS</h3>
      </div>
      <div class="card-body">

        <!-- ── BARRA DE PESTAÑAS (TABS) ────────────────────────────────────────── -->
        <div class="btn-group mb-4 w-100" role="group">
          <button type="button" class="btn" [ngClass]="tabActiva === 'terminales' ? 'btn-primary active fw-bold shadow' : 'btn-outline-primary'" (click)="cambiarTab('terminales')">
            <i class="fas fa-cash-register me-2"></i> 1. Terminales
          </button>
          <button type="button" class="btn" [ngClass]="tabActiva === 'pruebas' ? 'btn-danger text-white active fw-bold shadow' : 'btn-outline-danger'" (click)="cambiarTab('pruebas')">
            <i class="fas fa-vial me-2"></i> 2. Panel de Casos de Prueba C2C
          </button>
          <button type="button" class="btn" [ngClass]="tabActiva === 'transacciones' ? 'btn-info text-white active fw-bold shadow' : 'btn-outline-info'" (click)="cambiarTab('transacciones')">
            <i class="fas fa-receipt me-2"></i> 3. Historial de Transacciones
            <span class="badge bg-light text-dark ms-2" *ngIf="transacciones.length">{{ transacciones.length }}</span>
          </button>
          <button type="button" class="btn" [ngClass]="tabActiva === 'webhook' ? 'btn-warning text-dark active fw-bold shadow' : 'btn-outline-warning'" (click)="cambiarTab('webhook')">
            <i class="fas fa-satellite-dish me-2"></i> 4. Logs de Webhook en Vivo
            <span class="badge bg-dark text-white ms-2" *ngIf="webhookLogs.length">{{ webhookLogs.length }}</span>
          </button>
        </div>

        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <!--  PESTAÑA 1: CONFIGURACIÓN Y TERMINALES                                -->
        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <div [hidden]="tabActiva !== 'terminales'">

          <!-- ── SECCIÓN 1: CONFIGURACIÓN DEL COMERCIO ──────────────────────── -->
          <div *ngIf="cargandoConfig" class="text-center py-3">
            <i class="fas fa-spinner fa-spin me-1"></i> Cargando configuración...
          </div>

          <div *ngIf="!cargandoConfig">
            <!-- Ambiente Integración -->
            <h6 class="text-warning mb-2"><i class="fas fa-flask me-1"></i> Ambiente de Integración (Pruebas)</h6>
            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label">Commerce Code</label>
                <input type="text" class="form-control form-control-sm"
                       [(ngModel)]="config.integracion.commerceCode"
                       placeholder="597029414300">
              </div>
              <div class="col-md-6">
                <label class="form-label">API Key (X-Client-Id)</label>
                <input type="text" class="form-control form-control-sm"
                       [(ngModel)]="config.integracion.apiKey"
                       placeholder="a8a79e7995fdf4eae89d9196e5d7734d">
              </div>
            </div>

            <!-- Ambiente Producción -->
            <h6 class="text-success mb-2"><i class="fas fa-check-circle me-1"></i> Ambiente de Producción</h6>
            <div class="row mb-3">
              <div class="col-md-6">
                <label class="form-label">Commerce Code</label>
                <input type="text" class="form-control form-control-sm"
                       [(ngModel)]="config.produccion.commerceCode"
                       placeholder="597098765432">
              </div>
              <div class="col-md-6">
                <label class="form-label">API Key (X-Client-Id)</label>
                <input type="password" class="form-control form-control-sm"
                       [(ngModel)]="config.produccion.apiKey"
                       placeholder="xyz-key-produccion">
              </div>
            </div>

            <!-- URL Notify -->
            <div class="row mb-3">
              <div class="col-12">
                <label class="form-label">URL de Notificación Webhook</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text"><i class="fas fa-link"></i></span>
                  <input type="text" class="form-control"
                         [(ngModel)]="config.urlNotify"
                         placeholder="https://terraapi.indeone.app/api/Transbank/webhook">
                </div>
                <small class="text-muted">Transbank enviará las notificaciones de pago a esta URL.</small>
              </div>
            </div>

            <!-- Interruptores de Activación -->
            <div class="row mb-3">
              <div class="col-12">
                <label class="form-label fw-bold">
                  <i class="fas fa-toggle-on me-1 text-warning"></i>
                  Activación del módulo de cobro Transbank
                </label>
                <div class="d-flex gap-4 mt-1">
                  <!-- Toggle Producción -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch"
                           id="switchProduccion"
                           [(ngModel)]="config.activoProduccion">
                    <label class="form-check-label" for="switchProduccion">
                      <span class="badge" [ngClass]="config.activoProduccion ? 'badge-success' : 'badge-secondary'">
                        {{ config.activoProduccion ? 'ON' : 'OFF' }}
                      </span>
                      <strong class="ms-1">Producción</strong>
                      <small class="text-muted d-block">Los vendedores ven el botón "Cobrar en Transbank"</small>
                    </label>
                  </div>
                  <!-- Toggle Localhost -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch"
                           id="switchLocalhost"
                           [(ngModel)]="config.activoLocalhost">
                    <label class="form-check-label" for="switchLocalhost">
                      <span class="badge" [ngClass]="config.activoLocalhost ? 'badge-warning' : 'badge-secondary'">
                        {{ config.activoLocalhost ? 'ON' : 'OFF' }}
                      </span>
                      <strong class="ms-1">Localhost</strong>
                      <small class="text-muted d-block">Visible cuando desarrollas en local</small>
                    </label>
                  </div>
                </div>
                <small class="text-muted mt-1 d-block">
                  <i class="fas fa-info-circle me-1"></i>
                  Con ambos en <strong>OFF</strong>, el módulo Transbank es invisible para todos. El webhook siempre recibe notificaciones.
                </small>
              </div>
            </div>

            <div class="d-flex justify-content-end mb-4">
              <button class="btn btn-success" [disabled]="guardandoConfig" (click)="guardarConfig()">
                <i class="fas fa-save me-1" *ngIf="!guardandoConfig"></i>
                <i class="fas fa-spinner fa-spin me-1" *ngIf="guardandoConfig"></i>
                Guardar Configuración
              </button>
            </div>
          </div>

          <!-- Separador visual -->
          <hr class="border-secondary my-4">

          <!-- ── SECCIÓN 2: CRUD TERMINALES ──────────────────────────────────── -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0"><i class="fas fa-cash-register me-2 text-primary"></i> Terminales Transbank</h5>
            <button class="btn btn-primary" (click)="crearTerminal()" *ngIf="!editandoTerminal">
              <i class="fa fa-plus me-1"></i> Nuevo Terminal
            </button>
          </div>

          <!-- Formulario de creación / edición -->
          <div class="card bg-dark border border-secondary mb-3" *ngIf="editandoTerminal">
            <div class="card-header py-2">
              <h6 class="mb-0">
                <i class="fas fa-edit me-1"></i>
                {{ terminalSeleccionado._id ? 'Editar Terminal' : 'Nuevo Terminal' }}
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4 mb-2">
                  <label class="form-label">Nombre del Terminal <span class="text-danger">*</span></label>
                  <input type="text" class="form-control form-control-sm"
                         [(ngModel)]="terminalSeleccionado.nombre"
                         placeholder="Caja Bodega San Clemente">
                </div>
                <div class="col-md-4 mb-2">
                  <label class="form-label">Terminal ID (Transbank) <span class="text-danger">*</span></label>
                  <input type="text" class="form-control form-control-sm"
                         [(ngModel)]="terminalSeleccionado.terminalId"
                         placeholder="1854750567">
                </div>
                <div class="col-md-4 mb-2">
                  <label class="form-label">Sucursal</label>
                  <input type="text" class="form-control form-control-sm"
                         [(ngModel)]="terminalSeleccionado.sucursal"
                         placeholder="San Clemente">
                </div>
                <div class="col-md-4 mb-2">
                  <label class="form-label">Ambiente</label>
                  <select class="form-control form-control-sm" [(ngModel)]="terminalSeleccionado.ambiente">
                    <option value="INTEGRACION">Integración (Pruebas)</option>
                    <option value="PRODUCCION">Producción</option>
                  </select>
                </div>
              </div>
              <div class="d-flex justify-content-end gap-2 mt-2">
                <button class="btn btn-secondary btn-sm" (click)="cancelarEdicion()">
                  <i class="fas fa-times me-1"></i> Cancelar
                </button>
                <button class="btn btn-primary btn-sm" [disabled]="cargando" (click)="guardarTerminal()">
                  <i class="fas fa-save me-1" *ngIf="!cargando"></i>
                  <i class="fas fa-spinner fa-spin me-1" *ngIf="cargando"></i>
                  Guardar Terminal
                </button>
              </div>
            </div>
          </div>

          <!-- Tabla de terminales -->
          <div *ngIf="cargando && terminales.length === 0" class="text-center py-3">
            <i class="fas fa-spinner fa-spin me-1"></i> Cargando terminales...
          </div>

          <div *ngIf="!cargando && terminales.length === 0" class="text-center text-muted py-4">
            <i class="fas fa-cash-register fa-2x mb-2 d-block opacity-50"></i>
            No hay terminales registrados. Haz clic en <strong>Nuevo Terminal</strong> para agregar uno.
          </div>

          <div class="table-responsive transbank-table-wrapper" *ngIf="terminales.length > 0">
            <ngx-table #table
              [configuration]="configuration"
              [data]="terminales"
              [columns]="columns">
            </ngx-table>
          </div>

        </div>

        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <!--  PESTAÑA 2: PANEL DE CASOS DE PRUEBA C2C (EXCEL CERTIFICACIÓN)        -->
        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <div [hidden]="tabActiva !== 'pruebas'">
          <div class="card bg-dark border border-secondary mb-4">
            <div class="card-header bg-secondary text-white py-2 d-flex justify-content-between align-items-center">
              <h6 class="mb-0"><i class="fas fa-vial me-2"></i> Ejecutor de Casos de Prueba C2C</h6>
              <span class="badge bg-warning text-dark">Ambiente: Integración QA</span>
            </div>
            <div class="card-body">
              <p class="small text-muted mb-3">
                <i class="fas fa-info-circle me-1 text-info"></i>
                Configura los parámetros de prueba, envíalos al Smart POS y copia el resultado en formato compatible con Excel (<strong>Cols E, F, G: Trace ID, Response JSON y Estado</strong>) con un solo clic.
              </p>

              <div class="row g-3 align-items-end">
                <div class="col-md-3">
                  <label class="form-label small fw-bold">Terminal Destino</label>
                  <select class="form-control form-control-sm" [(ngModel)]="pruebaTerminalId">
                    <option *ngFor="let t of terminales" [value]="t.terminalId">
                      {{ t.nombre }} (TID: {{ t.terminalId }} - {{ t.ambiente }})
                    </option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label small fw-bold">Monto ($ CLP)</label>
                  <input type="number" class="form-control form-control-sm" [(ngModel)]="pruebaMonto" placeholder="1000">
                </div>
                <div class="col-md-3">
                  <label class="form-label small fw-bold d-flex justify-content-between">
                    <span>Host ID / Referencia</span>
                    <a href="javascript:void(0)" class="text-info text-decoration-none" (click)="generarNuevaReferencia()">
                      <i class="fas fa-dice"></i> Generar
                    </a>
                  </label>
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="pruebaReferencia">
                </div>
                <div class="col-md-4">
                  <label class="form-label small fw-bold">Trace ID (Para STATUS o CANCEL)</label>
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="pruebaTraceId" placeholder="Ej: 9f8192c50-2b6b-4a3f-841f-...">
                </div>
              </div>

              <!-- Botones de Acción de Prueba -->
              <div class="d-flex gap-2 flex-wrap mt-4">
                <button type="button" class="btn btn-success fw-bold" (click)="ejecutarCobroPrueba()">
                  <i class="fas fa-credit-card me-1"></i> 1. Enviar Cobro (SALE)
                </button>
                <button type="button" class="btn btn-info text-white fw-bold" [disabled]="cargandoPrueba || !pruebaTraceId" (click)="ejecutarConsultaEstadoDirecto()">
                  <i class="fas fa-sync-alt me-1" [class.fa-spin]="cargandoPrueba"></i> 2. Consultar Estado (STATUS)
                </button>
                <button type="button" class="btn btn-danger fw-bold" [disabled]="cargandoPrueba || !pruebaTraceId" (click)="ejecutarCancelarDirecto()">
                  <i class="fas fa-ban me-1" [class.fa-spin]="cargandoPrueba"></i> 3. Cancelar Transacción (CANCEL)
                </button>
                <button type="button" class="btn btn-secondary" (click)="probarImpresionDirecta(terminales[0])" *ngIf="terminales.length > 0">
                  <i class="fas fa-print me-1"></i> 4. Test Impresión (PRINT)
                </button>
              </div>
            </div>
          </div>

          <!-- Guía Interactiva del Excel de Certificación -->
          <div class="card bg-dark border border-secondary">
            <div class="card-header py-2 d-flex justify-content-between align-items-center">
              <h6 class="mb-0 text-warning"><i class="fas fa-list-check me-2"></i> Guía de Casos de Prueba (Excel C2C)</h6>
              <small class="text-muted">Total: 65 casos tabulados</small>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                <table class="table table-dark table-striped table-hover table-sm align-middle mb-0">
                  <thead>
                    <tr class="table-active small text-muted">
                      <th>#</th>
                      <th>Flujo / Tipo</th>
                      <th>Nombre de la Prueba</th>
                      <th>Instrucción para el Operador en el POS</th>
                      <th class="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody class="small">
                    <!-- Casos Crédito -->
                    <tr>
                      <td>4</td>
                      <td><span class="badge bg-primary">SALE / Crédito</span></td>
                      <td><strong>Venta crédito con cuotas y parámetros desactivados</strong></td>
                      <td>Enviar cobro de $1.000 ➔ En POS pasar tarjeta Crédito y elegir cuotas.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-success" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td><span class="badge bg-primary">SALE / Crédito</span></td>
                      <td><strong>Venta crédito Sin Cuotas y Sin Propina</strong></td>
                      <td>Enviar cobro de $1.000 ➔ En POS pasar Crédito, 1 cuota y rechazar propina.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-success" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td><span class="badge bg-primary">SALE / Crédito</span></td>
                      <td><strong>Venta crédito Sin Cuotas y Con Propina</strong></td>
                      <td>Enviar cobro de $1.000 ➔ En POS pasar Crédito, 1 cuota y aceptar propina.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-success" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td><span class="badge bg-primary">SALE / Crédito</span></td>
                      <td><strong>Venta crédito 3 Cuotas Con Propina</strong></td>
                      <td>Enviar cobro de $1.000 ➔ En POS pasar Crédito, digitar 3 cuotas y aceptar propina.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-success" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td><span class="badge bg-primary">SALE / Crédito</span></td>
                      <td><strong>Venta crédito 3 Cuotas Sin Propina</strong></td>
                      <td>Enviar cobro de $1.000 ➔ En POS pasar Crédito, digitar 3 cuotas y rechazar propina.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-success" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>

                    <!-- Casos Débito -->
                    <tr>
                      <td>20</td>
                      <td><span class="badge bg-success">SALE / Débito</span></td>
                      <td><strong>Venta Débito con parámetros desactivados</strong></td>
                      <td>Enviar cobro de $1.000 ➔ En POS pasar tarjeta Débito e ingresar PIN.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-success" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>21</td>
                      <td><span class="badge bg-success">SALE / Débito</span></td>
                      <td><strong>Venta Débito con vuelto y Con propina</strong></td>
                      <td>Enviar cobro de $1.000 ➔ En POS pasar Débito, solicitar vuelto y aceptar propina.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-success" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>

                    <!-- Casos Status & Cancel -->
                    <tr>
                      <td>40</td>
                      <td><span class="badge bg-warning text-dark">STATUS</span></td>
                      <td><strong>Operación cancelada en Opere Tarjeta</strong></td>
                      <td>Enviar cobro ➔ En el POS presionar la tecla roja de Cancelar en pantalla inicial.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-warning" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>45</td>
                      <td><span class="badge bg-warning text-dark">STATUS</span></td>
                      <td><strong>Time out en Ingrese PIN</strong></td>
                      <td>Enviar cobro ➔ Pasar tarjeta Débito y no ingresar el PIN hasta que expire.</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-warning" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>65</td>
                      <td><span class="badge bg-danger">CANCEL</span></td>
                      <td><strong>Cancelar venta activa desde API</strong></td>
                      <td>Enviar cobro ➔ En el modal presionar "Cancelar cobro desde la Web".</td>
                      <td class="text-center">
                        <button class="btn btn-xs btn-outline-danger" (click)="pruebaMonto = 1000; generarNuevaReferencia(); ejecutarCobroPrueba()">
                          <i class="fas fa-play"></i> Probar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <!--  PESTAÑA 3: HISTORIAL DE TRANSACCIONES                                -->
        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <div [hidden]="tabActiva !== 'transacciones'">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0"><i class="fas fa-receipt me-2 text-info"></i> Historial de Transacciones (Últimas 100)</h5>
            <button class="btn btn-outline-info btn-sm" (click)="cargarTransacciones()" [disabled]="cargandoTransacciones">
              <i class="fas fa-sync-alt me-1" [class.fa-spin]="cargandoTransacciones"></i> Actualizar
            </button>
          </div>

          <div *ngIf="cargandoTransacciones" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x text-primary mb-2"></i>
            <p>Cargando historial de transacciones...</p>
          </div>

          <div *ngIf="!cargandoTransacciones && transacciones.length === 0" class="text-center text-muted py-5">
            <i class="fas fa-folder-open fa-3x mb-3 opacity-50"></i>
            <p>No se registran transacciones en el historial.</p>
          </div>

          <div class="table-responsive" *ngIf="!cargandoTransacciones && transacciones.length > 0">
            <table class="table table-dark table-striped table-hover align-middle table-sm">
              <thead>
                <tr class="table-active text-uppercase small text-muted">
                  <th>Fecha</th>
                  <th>Terminal</th>
                  <th>Referencia / Host ID</th>
                  <th>Monto</th>
                  <th>Estado</th>
                  <th>N° Autorización</th>
                  <th>Tarjeta</th>
                  <th>Ambiente</th>
                  <th class="text-center">Acciones para Excel</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tx of transacciones">
                  <td class="small">{{ tx.fechaCreacion | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td><strong>{{ tx.terminalNombre || tx.terminalId }}</strong></td>
                  <td><code>{{ tx.transactionHostId || tx.traceId }}</code></td>
                  <td class="fw-bold">${{ (tx.totalPayment || 0) | number:'1.0-0' }}</td>
                  <td>
                    <span class="badge" [ngClass]="{
                      'bg-success': tx.estado === 'APROBADO',
                      'bg-danger':  tx.estado === 'RECHAZADO',
                      'bg-warning text-dark': tx.estado === 'PENDIENTE',
                      'bg-secondary': tx.estado === 'CANCELADO'
                    }">
                      {{ tx.estado }}
                    </span>
                  </td>
                  <td>{{ tx.authorizationCode || 'N/A' }}</td>
                  <td>
                    <span *ngIf="tx.last4Digits">{{ tx.cardType }} ****{{ tx.last4Digits }}</span>
                    <span *ngIf="!tx.last4Digits" class="text-muted">-</span>
                  </td>
                  <td>
                    <span class="badge" [ngClass]="tx.ambiente === 'PRODUCCION' ? 'badge-success' : 'badge-warning'">
                      {{ tx.ambiente }}
                    </span>
                  </td>
                  <td class="text-center">
                    <div class="d-flex gap-1 justify-content-center">
                      <button class="btn btn-xs btn-success" (click)="copiarFilaExcel(tx.traceId, tx, tx.estado === 'APROBADO' ? 'EXITOSA' : 'FALLIDA')" title="Copiar Fila para Excel (Cols E, F, G)">
                        <i class="fas fa-file-excel me-1"></i> Excel
                      </button>
                      <button class="btn btn-xs btn-outline-info" (click)="copiarTexto(tx.traceId, 'Trace ID')" title="Copiar Trace ID">
                        <i class="fas fa-copy"></i>
                      </button>
                      <button class="btn btn-xs btn-secondary" (click)="verVoucherTransaccion(tx)" title="Ver Detalle y JSON">
                        <i class="fas fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <!--  PESTAÑA 4: LOGS DE WEBHOOK EN VIVO                                   -->
        <!-- ═════════════════════════════════════════════════════════════════════ -->
        <div [hidden]="tabActiva !== 'webhook'">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0"><i class="fas fa-satellite-dish me-2 text-warning"></i> Registro de Notificaciones del Webhook</h5>
            <button class="btn btn-outline-warning btn-sm" (click)="cargarWebhookLogs()" [disabled]="cargandoWebhookLogs">
              <i class="fas fa-sync-alt me-1" [class.fa-spin]="cargandoWebhookLogs"></i> Actualizar
            </button>
          </div>

          <div *ngIf="cargandoWebhookLogs" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x text-warning mb-2"></i>
            <p>Consultando eventos del webhook...</p>
          </div>

          <div *ngIf="!cargandoWebhookLogs && webhookLogs.length === 0" class="text-center text-muted py-5">
            <i class="fas fa-inbox fa-3x mb-3 opacity-50"></i>
            <p>No se han recibido llamadas en el Webhook todavía.</p>
          </div>

          <div class="table-responsive" *ngIf="!cargandoWebhookLogs && webhookLogs.length > 0">
            <table class="table table-dark table-striped table-hover align-middle table-sm">
              <thead>
                <tr class="table-active text-uppercase small text-muted">
                  <th>Fecha / Hora</th>
                  <th>IP Origen</th>
                  <th>Trace ID / Host ID</th>
                  <th>Auth Code</th>
                  <th>Resp Code</th>
                  <th>Resultado Procesamiento</th>
                  <th class="text-center">Acciones para Excel</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of webhookLogs">
                  <td class="small">{{ log.fecha | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td class="small text-muted">{{ log.ip }}</td>
                  <td><code>{{ log.traceId || log.transactionHostId || 'N/A' }}</code></td>
                  <td>{{ log.authorizationCode || 'N/A' }}</td>
                  <td>
                    <span class="badge" [ngClass]="log.responseCode === '0' ? 'bg-success' : 'bg-danger'">
                      {{ log.responseCode || 'N/A' }}
                    </span>
                  </td>
                  <td class="small">{{ log.resultadoProcesamiento }}</td>
                  <td class="text-center">
                    <div class="d-flex gap-1 justify-content-center">
                      <button class="btn btn-xs btn-success" (click)="copiarFilaExcel(log.traceId || log.transactionHostId, log.rawBody, log.resultadoProcesamiento?.includes('APROBADO') ? 'EXITOSA' : 'FALLIDA')" title="Copiar Fila para Excel (Cols E, F, G)">
                        <i class="fas fa-file-excel me-1"></i> Excel
                      </button>
                      <button class="btn btn-xs btn-outline-info" (click)="copiarTexto(log.traceId || log.transactionHostId, 'Trace ID')" title="Copiar Trace ID">
                        <i class="fas fa-copy"></i>
                      </button>
                      <button class="btn btn-xs btn-outline-warning" (click)="verDetalleWebhook(log)" title="Ver JSON Crudo">
                        <i class="fas fa-code me-1"></i> JSON
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ── TEMPLATES DE COLUMNAS PERSONALIZADAS PARA NGX-TABLE (NIVEL RAÍZ) ── -->
        <ng-template #frmAmbiente let-row>
          <span class="badge" [ngClass]="row.ambiente === 'PRODUCCION' ? 'badge-success' : 'badge-warning'">
            {{ row.ambiente === 'PRODUCCION' ? 'Producción' : 'Integración' }}
          </span>
        </ng-template>

        <ng-template #frmAccion let-row let-rowIndex="rowIndex">
          <div class="d-flex gap-1 flex-wrap">
            <button type="button" class="btn btn-info btn-xs text-white" (click)="probarImpresionDirecta(row)"
                    title="Probar Impresión en el POS">
              <i class="fas fa-print me-1"></i> Imprimir
            </button>
            <button type="button" class="btn btn-warning btn-xs text-dark fw-bold" (click)="probarCobroDirecto(row)"
                    title="Probar Cobro en el POS (Monto personalizable)">
              <i class="fas fa-credit-card me-1"></i> Cobrar...
            </button>
            <button type="button" class="btn btn-success btn-xs" (click)="editarTerminal(row)"
                    title="Editar">
              <i class="fas fa-edit"></i>
            </button>
            <button type="button" class="btn btn-danger btn-xs" (click)="eliminarTerminal(row)"
                    title="Eliminar">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>

